export { default } from './VideoPlayback';



// WEBPACK FOOTER //
// ./app/components/shared/UGC/VideoPlayback/index.js